module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/css/housekeeping.component.css
// module id = ./src/app/modules/housekeeping/css/housekeeping.component.css
// module chunks = main